<template>
    <div class="sms-log-container">

        <div class="row align-items-end mb-3  ">
            <div class="col-lg-3 col-sm-6 col-12 mb-3 searchText">
                <label></label>
                <search-input
                        class="search-input date-time-margin"
                        type="text"
                        v-model="SearchText"
                        placeholder="Search for text"
                />
            </div>
            <div class="col-lg-3 col-sm-6 col-12 mb-3 equal-field box">
                <primary-select :options="companies" v-model="company"
                                placeholder="Select Company"/>
            </div>
            <div class="col-lg-3 col-sm-6 col-12 mb-3 equal-field date-picker">
                <date-time-picker
                        class="date-time-margin"
                        header="Start Date:"
                        :initial_time="new Date(startTime)"
                        @getTime="getStartTime"
                ></date-time-picker>
            </div>
            <div class="col-lg-3 col-sm-6 col-12 mb-3 equal-field date-picker">
                <date-time-picker
                        header="End Date:"
                        :initial_time="new Date(endTime)"
                        @getTime="getEndTime"
                ></date-time-picker>
            </div>
            <div class="col-12 btns d-flex justify-content-end">
                <div class="reset-button mr-sm-3 mr-2">
                    <button class="PrimaryButton ff-p fw-5 fs-15" @click="search">
                        Submit
                    </button>
                </div>
                <div class="reset-button">
                    <button class="secondary-button" @click="reasetFilters">
                        Reset
                    </button>
                </div>
            </div>
        </div>

        <loader :loading="loading" v-if="loading"/>
        <not-found v-else-if="!bulkReports.length || !showData"/>
        <template v-else-if="!loading">
            <div
                    class="table_div"
                    style="width: 100%; overflow-x: auto; overflow-y: hidden"
            >
                <table class="Invoice_table">
                    <thead>
                    <tr class="Invoice_table_header">
                        <th>Bulk UUID</th>
                        <th>
                            Created on
                            <span @click="sorting('up', 'started_at')" class="sorting"
                            >&#8593;</span
                            >
                            <span @click="sorting('down', 'started_at')" class="sorting"
                            >&#8595;</span
                            >
                        </th>
                        <th>Status</th>
                        <th>Count</th>
                        <th>Sent</th>
                        <th>Failed</th>
                        <th>Success</th>
                        <th>Rejected</th>
                        <th>Text</th>
<!--                        <th>Action</th>-->
                    </tr>
                    </thead>
                    <tbody v-if="bulkReports.length > 0">
                    <tr class="line" v-for="(bulk, k) in bulkReports" :key="k">
                        <th
                                class="text bulk-uuid"
                                :title="bulk.bulk_uuid"
                        >
                            {{ bulk.bulk_uuid | shortText(text_length) }}
                        </th>
                        <th class="time-th">{{ dateFormat(bulk.started_at) }}</th>
                        <th>{{ bulk.status }}</th>
                        <!--                        <th :class="bulk.dest_count > 0 ? 'clickable-th' : ''"-->
                        <!--                            @click="downloadNumbers(bulk.bulk_uuid, bulk.dest_count, 'Count')">{{ bulk.dest_count }}-->
                        <!--                        </th>-->
                        <!--                        <th :class="bulk.dest_sent > 0 ? 'clickable-th' : ''"-->
                        <!--                            @click="downloadNumbers(bulk.bulk_uuid, bulk.dest_sent, 'Sent')">{{ bulk.dest_sent }}-->
                        <!--                        </th>-->
                        <!--                        <th :class="bulk.route_status_sending_failed_count > 0 ? 'clickable-th' : ''"-->
                        <!--                            @click="downloadNumbers(bulk.bulk_uuid, bulk.route_status_sending_failed_count, 'Failed')">-->
                        <!--                            {{ bulk.route_status_sending_failed_count }}-->
                        <!--                        </th>-->
                        <!--                        <th :class="bulk.route_status_sent_to_vendor_count > 0 ? 'clickable-th' : ''"-->
                        <!--                            @click="downloadNumbers(bulk.bulk_uuid, bulk.route_status_sent_to_vendor_count, 'Success')">-->
                        <!--                            {{ bulk.route_status_sent_to_vendor_count }}-->
                        <!--                        </th>-->
                        <!--                        <th :class="bulk.route_status_rejected_count > 0 ? 'clickable-th' : ''"-->
                        <!--                            @click="downloadNumbers(bulk.bulk_uuid, bulk.route_status_rejected_count, 'Rejected')">{{-->
                        <!--                            bulk.route_status_rejected_count }}-->
                        <!--                        </th>-->

                        <th :class="bulk.dest_count > 0 ? 'clickable-th' : ''"
                        >{{ bulk.dest_count }}
                        </th>
                        <th :class="bulk.dest_sent > 0 ? 'clickable-th' : ''"
                        >{{ bulk.dest_sent }}
                        </th>
                        <th :class="bulk.route_status_sending_failed_count > 0 ? 'clickable-th' : ''"
                        >
                            {{ bulk.route_status_sending_failed_count }}
                        </th>
                        <th :class="bulk.route_status_sent_to_vendor_count > 0 ? 'clickable-th' : ''"
                        >
                            {{ bulk.route_status_sent_to_vendor_count }}
                        </th>
                        <th :class="bulk.route_status_rejected_count > 0 ? 'clickable-th' : ''"
                        >{{
                            bulk.route_status_rejected_count }}
                        </th>

                        <th class="text" :title="bulk.text">
                            {{ bulk.text }}
                        </th>
<!--                        <th>-->
                            <!--                            <svg-->
                            <!--                                    version="1.1"-->
                            <!--                                    id="Capa_1"-->
                            <!--                                    xmlns="http://www.w3.org/2000/svg"-->
                            <!--                                    xmlns:xlink="http://www.w3.org/1999/xlink"-->
                            <!--                                    x="0px"-->
                            <!--                                    y="0px"-->
                            <!--                                    viewBox="0 0 30.05 30.05"-->
                            <!--                                    xml:space="preserve"-->
                            <!--                                    width="25px"-->
                            <!--                                    height="25px"-->
                            <!--                                    class="svg-grey mr-2"-->
                            <!--                            >-->
                            <!--                  <title>Stop</title>-->
                            <!--                                <g>-->
                            <!--                    <g>-->
                            <!--                      <path-->
                            <!--                              style="fill: #55616e"-->
                            <!--                              d="M18.993,10.688h-7.936c-0.19,0-0.346,0.149-0.346,0.342v8.022c0,0.189,0.155,0.344,0.346,0.344-->
                            <!--		h7.936c0.19,0,0.344-0.154,0.344-0.344V11.03C19.336,10.838,19.183,10.688,18.993,10.688z"-->
                            <!--                      />-->
                            <!--                        <path-->
                            <!--                                style="fill: #55616e"-->
                            <!--                                d="M15.026,0C6.729,0,0.001,6.726,0.001,15.025S6.729,30.05,15.026,30.05-->
                            <!--		c8.298,0,15.023-6.726,15.023-15.025S23.324,0,15.026,0z M15.026,27.54c-6.912,0-12.516-5.604-12.516-12.515-->
                            <!--		c0-6.914,5.604-12.517,12.516-12.517c6.913,0,12.514,5.603,12.514,12.517C27.54,21.936,21.939,27.54,15.026,27.54z"-->
                            <!--                        />-->
                            <!--                    </g>-->
                            <!--                  </g>-->
                            <!--                </svg>-->

                            <!--                            <svg-->
                            <!--                                    aria-hidden="true"-->
                            <!--                                    focusable="false"-->
                            <!--                                    data-prefix="far"-->
                            <!--                                    data-icon="play-circle"-->
                            <!--                                    class="svg-grey svg-inline&#45;&#45;fa fa-play-circle fa-w-16"-->
                            <!--                                    role="img"-->
                            <!--                                    xmlns="http://www.w3.org/2000/svg"-->
                            <!--                                    viewBox="0 0 512 512"-->
                            <!--                                    width="25px"-->
                            <!--                                    height="25px"-->
                            <!--                                    style="margin-left: 3px"-->
                            <!--                            >-->
                            <!--                                <title>Run</title>-->
                            <!--                                <path-->
                            <!--                                        fill="#55616e"-->
                            <!--                                        d="M371.7 238l-176-107c-15.8-8.8-35.7 2.5-35.7 21v208c0 18.4 19.8 29.8 35.7 21l176-101c16.4-9.1 16.4-32.8 0-42zM504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256z"-->
                            <!--                                />-->
                            <!--                            </svg>-->
<!--                        </th>-->
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="per-page-box">
                <div class="header">
                    <span class="filter_by per_page">Show Per Page</span>
                </div>
                <div class="item">
                    <div
                            class="primary-input-container choose-type perPage equal-field box"
                            type="text"
                            placeholder="Select"
                    >
                        <div class="primary-select-wrapper">
                            <select v-model="per_page" :is-cross="false">
                                <option
                                        v-for="page in pages"
                                        :key="page.name"
                                        :value="page.value"
                                >
                                    {{ page.value }}
                                </option>
                            </select>
                            <img src="/img/Down.08f08d5c.svg" alt class="icon-down"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="buttons-wrapper">
                <pagination-component
                        @change-page="changePage($event)"
                        :page="Page"
                        :total="getTotal / per_page"
                        :perPage="per_page"
                        :qnt="bulkReports.length"
                />
            </div>
        </template>
    </div>
</template>

<script>
    import {format} from "date-fns";
    import {mapGetters, mapActions} from "vuex";
    import axios from "axios";

    export default {
        components: {
            SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
            SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
            PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
            PaginationComponent: () => import("@/components/Pagination.vue"),
            PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
            Loader: () => import("@/components/Loader.vue"),
            NotFound: () => import("@/components/NotFound.vue"),
            DateTimePicker: () => import("@/components/DateTime"),
        },
        data: () => ({
            pages: [
                {name: 10, value: 10},
                {name: 50, value: 50},
                {name: 100, value: 100},
            ],
            per_page: 10,
            Page: 0,
            total: 0,
            loading: true,
            showData: Boolean,
            isShow: true,
            start_time: null,
            end_time: null,
            bulkReport: [],
            totalPages: null,
            isClicked: false,
            SearchText: null,
            text_length: 30,
            companies: [],
            company: "",
        }),
        computed: {
            ...mapGetters({
                bulkReports: "bulk/getBulkAutoSubstitutingReport",
                bulkTotalPages: "bulk/getTotalAutoSubstitutingPages",
                getTotal: "bulk/getTotalAutoSubstituting",
            }),
            startTime() {
                const {day, month, year} = this.getCurrentDateAndTime();

                return new Date(`${month}/${day}/${year} 00:00:00`).getTime();
            },
            endTime() {
                const {day, month, year} = this.getCurrentDateAndTime();

                return new Date(`${month}/${day}/${year} 23:59:59`).getTime();
            },
        },
        watch: {
            per_page(data) {
                this.Page = 0;
                this.getBulkReports();
            },
            // company(val) {
            //     this.getBulkReports();
            // }
        },
        filters: {
            shortText(txt, length) {
                if (txt && txt.length > length) {
                    return `${txt.substr(0, length)}...`;
                }

                return txt;
            },
        },
        async created() {
            this.setDateAndTime();
            this.getBulkReports();
            this.getCompanies();
        },
        methods: {
            ...mapActions({
                viewBulkReports: "bulk/getBulkAutoSubstitutingReport",
            }),
            async getCompanies() {
                return axios({
                    url: "/company/list",
                    method: "GET",
                    params: {}
                }).then(res => {
                    this.companies = [
                        ...res.data.payload.items.map(this.transformCompany).filter((item) => item.name),
                    ];
                }).catch(err => {
                    console.log(err)
                })
            },
            async getBulkReports(order_dir = "desc", order_by = "started_at") {
                this.loading = true;
                await this.viewBulkReports({
                    start_time: new Date(this.start_time * 1000).toGMTString(),
                    end_time: new Date(this.end_time * 1000).toGMTString(),
                    per_page: this.per_page,
                    page: this.Page,
                    text: this.SearchText || null,
                    order_dir: order_dir,
                    order_by: order_by,
                    company_uuid: this.company || null
                });
                this.loading = false;
                console.log("bulk -> ", this.bulkReports);
            },
            sorting(type, sortBy) {
                let order_dir = "desc";
                if (type === "up") {
                    order_dir = "desc";
                } else {
                    order_dir = "asc";
                }

                // this.order_dir = order_dir;
                // this.order_by = sortBy;

                this.getBulkReports(order_dir, sortBy);
            },
            getStartTime(t) {
                const time = new Date(t).getTime();
                this.start_time = time / 1000;
            },
            getEndTime(t) {
                const time = new Date(t).getTime();
                this.end_time = time / 1000;
            },
            oneToTwoDigit(num) {
                return num.length === 1 ? `0${num}` : num;
            },
            transformCompany(item) {
                return {
                    name: item.company_name && item.company_name.trim(),
                    value: item.company_uuid,
                };
            },
            dateFormat(date) {
                if (date == null) {
                    return "";
                }
                const converted_date = new Date(date);
                const year = converted_date.getFullYear().toString();
                const _month = (converted_date.getMonth() + 1).toString();
                const month = this.oneToTwoDigit(_month);
                const _day = converted_date.getDate().toString();
                const day = this.oneToTwoDigit(_day);
                const _hours = converted_date.getHours().toString();
                const hours = this.oneToTwoDigit(_hours);
                const _minutes = converted_date.getMinutes().toString();
                const minutes = this.oneToTwoDigit(_minutes);
                const _seconds = converted_date.getSeconds().toString();
                const seconds = this.oneToTwoDigit(_seconds);

                return `${year}:${month}:${day} ${hours}:${minutes}:${seconds}`;
            },
            getCurrentDateAndTime() {
                const date = new Date();
                const day = date.getDate();
                const month = date.getMonth() + 1;
                const year = date.getFullYear();

                return {day, month, year};
            },
            setDateAndTime() {
                this.start_time = this.startTime / 1000;
                this.end_time = this.endTime / 1000;
            },

            selectDateAndTime(e) {
                this.start_time = new Date(e[0]).getTime() / 1000;
                this.end_time = new Date(e[1]).getTime() / 1000;
                this.Page = 0;
            },
            showText(e, text) {
                e.target.children[0].innerHTML = text;
            },
            reasetFilters() {
                // if(!this.SearchText) {return}
                // this.SearchText = '';
                // this.getBulkReports();
                this.$router.go(0)
            },
            changePage(page) {
                this.Page = page;
                this.getBulkReports();
            },
            search() {
                this.getBulkReports();
            },
        },
    };
</script>

<style lang="scss" scoped>
    .equal-field {
        width: 230px !important;
    }

    .sms-log-container {
        padding: 0 20px;

        .per-page-box {
            display: flex;
            align-items: center;
            margin-top: 20px;

            .header {
                margin-right: 10px;
            }

            .item {
                width: 120px;

                div,
                select {
                    width: 120px;
                }
            }
        }

        .time-th {
            min-width: 180px;
        }

        [data-title]:hover:after {
            opacity: 1;
            transition: all 0.1s ease 0.5s;
            visibility: visible;
        }

        [data-title]:after {
            content: attr(data-title);
            background-color: white;
            color: #111;
            font-size: 15px;
            position: absolute;
            padding: 6px 10px;
            top: 3em;
            left: 0%;
            width: auto;
            box-shadow: 1px 1px 3px #343232;
            opacity: 0;
            height: auto;
            border: 1px solid grey;
            z-index: 99999;
            // visibility: hidden;
        }

        [data-title] {
            position: relative;
        }

        .add-navigation {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: auto;
            margin-top: 20px;
            margin-bottom: 50px;

            .right-wrapper {
                display: flex;
                width: 100%;
                flex-direction: row-reverse;
                align-items: center;
                // margin: 0 auto;

                .first-line {
                    display: flex;
                    justify-content: space-between;
                    // width: 100%;

                    .search-boxes {
                        display: block;
                        margin-top: 15px;

                        div {
                            float: left;
                            margin-right: 22px;
                            // margin-top: 15px;
                        }

                        div:first-child {
                            margin-left: 0;
                        }

                        div:last-child {
                            margin-right: 0;
                        }
                    }

                    .btns {
                        display: flex;
                        justify-content: flex-end;
                        align-items: center;
                        align-content: flex-start;
                    }
                }

                .search-input {
                    position: relative;
                    display: flex;
                    align-items: center;
                    width: 100%;
                    height: 40px;
                    margin-right: 10px;
                    background-color: #fff;

                    .icon {
                        left: 5px;
                        position: absolute;
                        height: 30px;
                        width: 30px;
                    }

                    input {
                        z-index: 2;
                        width: 100%;
                        height: 100%;
                        border: 1px solid #edeef3;
                        border-radius: 4px;
                        background-color: #fff;
                        font-family: Helvetica Neue;
                        font-size: 16px;
                        line-height: 25px;
                        padding-left: 40px;
                        background-color: transparent;
                    }
                }

                .reset-button {
                    width: 90px;
                    height: 40px;
                    margin: 10px 0 0 10px;
                }

                .second-line {
                    display: flex;
                    width: 100%;

                    .searchText {
                        margin-top: 5px;
                        max-width: 300px;
                    }

                    .selects-wrapper {
                        display: flex;
                        justify-content: flex-start;
                        width: 100% !important;
                        // margin-bottom: 30px;

                        .parent-item {
                            display: flex;

                            .item {
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                width: 100%;
                                margin: 0 10px;
                                flex-grow: 1;

                                div {
                                    display: inline-block;
                                }
                            }
                        }

                        .parent-item:first-child {
                            .item:first-child {
                                margin-left: 0;
                            }
                        }

                        .parent-item:last-child {
                            .item:last-child {
                                margin-right: 0;
                            }
                        }

                        .per_page {
                            width: 110px;
                        }

                        .choose-type {
                            height: 40px;
                            color: #55616e;
                            font-weight: 400;
                        }

                        .inputs {
                            display: flex;

                            div {
                                margin-right: 10px;
                            }

                            &:last-child {
                                // margin-top: 25px;

                                div.el-date-editor {
                                    width: 485px;
                                }
                            }

                            .equal-field.date-picker {
                                margin-right: 20px;
                            }

                            &.date-inputs div:first-child {
                                margin-bottom: 5px;
                            }
                        }
                    }

                    .btns {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin-top: 30px;
                    }

                    .header {
                        margin-bottom: 5px;
                        font-family: Helvetica Neue;
                        font-size: 16px;
                        font-weight: 400;
                        // text-align: center;
                        color: #55616e;
                    }
                }
            }
        }
    }

    .word-break {
        word-break: break-all;
        max-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin: 0;
    }

    .box.equal-field {
        width: 232px !important;
    }

    .PrimaryButton {
        cursor: pointer;
        height: 40px;
        width: 100%;
        border-radius: 4px;
        background-color: #51a3f3;
        color: #fff;
        outline: none;
        border: none;
        font-family: "Helvetica Neue";
        font-size: 16px;
        font-weight: 500;
        line-height: 30px;
        text-align: center;
        padding: 5px 20px 5px 20px;
    }

    .secondary-button {
        cursor: pointer;
        height: 100%;
        width: 100%;
        border: 1px solid #bdbfd8;
        border-radius: 4px;
        background-color: #fff;
        color: #55616e;
        font-family: "Helvetica Neue";
        font-size: 16px;
        font-weight: 500;
        line-height: 18px;
        text-align: center;
        padding: 10px 20px 10px 20px;
    }

    table.Invoice_table {
        width: 100%;

        th {
            text-align: center;

            &.bulk-uuid {
                width: 300px;
                padding-left: 0;
                padding-right: 0;
            }
        }
    }

    table thead tr {
        background: linear-gradient(135deg, #51a3f3 0%, #51b5f3 100%);

        th {
            border-bottom-width: 2px;
            color: white;
            padding-left: 10px;
            vertical-align: bottom;
            border-bottom: 2px solid #dee2e6;
            border: 1px solid #dee2e6;
        }
    }

    table,
    tr {
        width: 100%;
        box-shadow: inset 0 -1px 0 0 #f0f1fa;
        -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
        -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
        background-color: #ffffff;
    }

    table {
        border-collapse: collapse;
    }

    .Invoice_table_popup {
        width: 75px;
    }

    .Invoice_table_header th {
        color: white;
        padding-left: 10px;
        border-bottom-width: 2px;
        vertical-align: bottom;
        border-bottom: 2px solid #dee2e6;
        border: 1px solid #dee2e6;
        padding: 0.75rem;
        text-align: center;

        .sorting {
            cursor: pointer;
        }
    }

    .Invoice_table_header th:first-child {
        padding-left: 20px;
        padding-right: 30px;
        width: 300px;
    }

    tbody th:first-child {
        padding-left: 20px;
        padding-right: 30px;
    }

    tbody th {
        height: 40px;
        color: #212b36;
        font-weight: normal;
        font-family: "Helvetica Neue";
        font-size: 14px;
        line-height: 20px;
        padding: 15px 20px;
    }

    tr th.icon {
        width: 80x;
        float: right;
    }

    tbody {
        th.icon {
            padding: 7px 20px 7px 0;

            .edit {
                margin-right: 20px;
            }
        }

        .img-container {
            padding: 7px 0;
        }

        th.text {
            min-width: 150px;

            span {
                pointer-events: none;
            }
        }
    }

    .Invoice_price {
        font-family: "Helvetica Neue";
    }

    .popup_image {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        vertical-align: middle;
        margin-right: 8px;
    }

    th.user_active:after {
        content: "";
        height: 10px;
        width: 10px;
        background-color: #24e2b8;
        position: absolute;
        border-radius: 50%;
        left: 12px;
        top: 20px;
    }

    th.user_active {
        text-align: left;
        position: relative;
        padding-left: 35px;
    }

    th .svg-grey {
        cursor: pointer;
        fill: #55616e;
    }

    th .callflow {
        font-size: 12px;
        width: 86px;
        height: 20px;
        padding-top: 0px;
        float: right;
        line-height: 20px;
    }

    th .number-icon {
        height: 16px;
        width: 16px;
        margin-right: 8px;
    }

    .primary-input-container {
        .primary-select-wrapper {
            box-sizing: border-box;
            position: relative;
            display: flex;
            align-items: center;
            width: 100%;
            height: 40px;
            border: 1px solid #edeef3;
            border-radius: 4px;
            background-color: #fff;

            select {
                -webkit-appearance: none;
                -moz-appearance: none;
                -ms-appearance: none;
                appearance: none;
                width: 100%;
                // height: 100%;
                min-height: 38px;
                background: #fff;
                padding-left: 15px;
                font-family: Helvetica Neue;
                font-size: 16px;
                line-height: 25px;
            }

            .icon-down {
                left: 100%;
                margin-left: -35px;
                background: #fff;
            }
        }

        .pimary-input-title {
            color: #000;
            font-family: "Helvetica Neue";
            font-size: 12px;
            font-weight: 300;
            letter-spacing: 0.21px;
            line-height: 15px;
            margin-bottom: 5px;
            text-transform: uppercase;
        }
    }

    .no-data-found {
        padding: 20px;
        text-align: center;
        font-size: 20px;
        color: #e2e5ea;
        background-color: #fff;
    }

    .table_div::-webkit-scrollbar {
        // width: 5px;
        width: 8px;
        height: 8px;
        background-color: #f5f5f5;
    }

    .table_div::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-image: -webkit-gradient(
                        linear,
                        left bottom,
                        left top,
                        color-stop(0.44, #51a3f3),
                        color-stop(0.72, #51a3f3),
                        color-stop(0.86, #51a3f3)
        );
    }

    .table_div::-webkit-scrollbar {
        // width: 5px;
        width: 8px;
        height: 8px;
        background-color: #f5f5f5;
    }

    .table_div::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-image: -webkit-gradient(
                        linear,
                        left bottom,
                        left top,
                        color-stop(0.44, #51a3f3),
                        color-stop(0.72, #51a3f3),
                        color-stop(0.86, #51a3f3)
        );
    }

    @media screen and (max-width: 1775px) {
        .sms-log-container .add-navigation .right-wrapper {
            display: flex;
            width: 100%;
            // flex-direction: column-reverse;

            .first-line {
                margin-top: 15px;

                .btns {
                    flex-grow: 1;
                }
            }

            .second-line .selects-wrapper .inputs {
                flex-wrap: wrap;
            }
        }
    }

    @media (max-width: 1670px) {
        table.Invoice_table {
            width: 1570px;
        }
    }

    @media screen and (max-width: 850px) {
        .sms-log-container .add-navigation .right-wrapper {
            width: 100%;
            flex-direction: row-reverse;
            align-items: flex-start;
            justify-content: space-between;
            // padding: 0 15%;
        }
        .sms-log-container .add-navigation .right-wrapper .first-line {
            width: fit-content;
            flex-direction: column;
        }
        .sms-log-container .add-navigation .right-wrapper .second-line {
            flex-direction: column;
        }
        .sms-log-container .add-navigation .right-wrapper .first-line .search-boxes {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 26px;
            // padding-top: 24px;
        }
        .sms-log-container .add-navigation .right-wrapper .first-line .btns {
            width: 230px;
            justify-content: center;
        }
        .sms-log-container .add-navigation .right-wrapper .second-line .searchText {
            max-width: 245px;
            padding-left: 0px !important;
        }
        .sms-log-container
        .add-navigation
        .right-wrapper
        .first-line
        .search-boxes
        div:first-child {
            margin-top: 0;
        }
        .sms-log-container
        .add-navigation
        .right-wrapper
        .first-line
        .search-boxes
        div {
            margin: 38px 0 0;
            float: none;
        }
        .sms-log-container
        .add-navigation
        .right-wrapper
        .first-line
        .search-boxes
        div:last-child {
            margin-right: 0;
        }
        .sms-log-container
        .add-navigation
        .right-wrapper
        .first-line
        .btns
        div:first-child {
            margin: 10px 0 0 0;
        }
        .sms-log-container .add-navigation .right-wrapper .first-line .btns {
            justify-content: space-between;
        }
        .sms-log-container
        .add-navigation
        .right-wrapper
        .second-line
        .selects-wrapper
        .inputs {
            flex-direction: column;
            align-items: center;
        }
        .sms-log-container
        .add-navigation
        .right-wrapper
        .second-line
        .selects-wrapper
        .inputs
        .item:first-child {
            margin-top: 0 !important;
        }
        .sms-log-container
        .add-navigation
        .right-wrapper
        .second-line
        .selects-wrapper
        .inputs
        .item {
            margin: 38px 0 0 !important;
        }
        .sms-log-container
        .add-navigation
        .right-wrapper
        .second-line
        .per-page-box
        .item
        div {
            margin: 0 auto;
        }
    }

    @media (max-width: 830px) {
        .sms-log-container .add-navigation .right-wrapper {
            display: flex;
            flex-direction: column-reverse;

            .first-line {
                width: 100%;
                margin-top: 0;

                .search-boxes {
                    flex-direction: row;

                    .equal-field:last-child {
                        margin: 0 0 0 10px;
                    }
                }
            }
        }
    }

    /*.clickable-th {*/
    /*    transition: .2s;*/

    /*    &:hover {*/
    /*        cursor: pointer;*/
    /*        color: #51A3F3;*/
    /*        transform: scale(1.2);*/
    /*        transition: .2s;*/
    /*    }*/
    /*}*/

    .date-time-margin {
        margin-top: -5px;
    }

    .align-items-end {
        margin-top: 12px;
    }
</style>
